
export type CompanyPlanLevelType =
    "trial" |
    "basic" |
    "standard" |
    "premium";


export const CompanyPlanLevel = (Object.freeze({
    TRIAL: 'trial',
    BASIC: 'basic',
    STANDARD: 'standard',
    PREMIUM: 'premium'
}));

export const CompanyPlanStatus = (Object.freeze({
    ACTIVE: 'active',
    GRACE: 'grace',
    SUSPENDED: 'suspended'
}));
